<template>
	<DashboardModal
		ref="modal"
		dialog
		width="500px"
		@modal-toggle="$emit('modal-toggle')"
	>
		<DashboardFormTitle :class="$style['title']">
			{{ $t('edit-table-modal-view.title') }}
		</DashboardFormTitle>
		<span :class="$style['sub-title']">{{ $t('edit-table-modal-view.subtitle') }}</span>
		<Spinner
			v-if="loading"
			:center="true"
		/>
		<template v-else>
			<ul
				:class="$style['list']"
			>
				<li
					v-for="(item, index) in originalList"
					:key="index"
					:class="$style['list__item']"
				>
					<BaseCheckbox
						style="margin-right: 10px;"
						:label="item.tagKey ? $t('common.fields.' + item.tagKey) : item.tag || item.name"
						:indeterminate="checkIfParentSelected(item).indeterminate"
						:checked="checkIfParentSelected(item).checked"
						@change="handleCheckboxClick(item)"
					/>
					<ul
						v-if="item.children && item.children.length"
						:class="$style['child-list']"
					>
						<li
							v-for="(child, i) in item.children"
							:key="i"
							:class="$style['child-list__item']"
						>
							<BaseCheckbox
								style="margin-right: 10px;"
								:label="child.tagKey ? $t('common.fields.' + child.tagKey) : child.tag || child.name"
								:checked="checkIfChildSelected(item, child)"
								@change="handleChildCheckboxClick(item, child)"
							/>
						</li>
					</ul>
				</li>
			</ul>
			<div :class="$style['modal__buttons']">
				<BaseButton
					full="true"
					:primary="true"
					:loading="loading"
					:class="$style['modal__button']"
					@click="handleSubmitForm"
				>
					{{ $t('common.buttons.save') }}
				</BaseButton>
				<BaseButton
					full="true"
					:white="true"
					:class="$style['modal__button']"
					@click="$emit('modal-toggle')"
				>
					{{ $t('common.actions.cancel') }}
				</BaseButton>
			</div>
		</template>
	</DashboardModal>
</template>

<script>
import cloneDeep from 'lodash.clonedeep'

import DashboardModal from '@/components/Layout/Dashboard/Modal'
import DashboardFormTitle from '@/components/Layout/Dashboard/Form/FormTitle'
import Spinner from '@c:essentials/Spinner'

export default {
	name: 'EditTableModal',
	components: {
		DashboardModal,
		DashboardFormTitle,
		Spinner
	},
	props: {
		originalList: {
			type: Array,
			default: () => []
		},
		savedList: {
			type: Array,
			default: () => []
		},
		loading: {
			type: Boolean,
			default: false
		},
		save: {
			type: Function,
			default: () => {}
		}
	},
	data () {
		return {
			localList: []
		}
	},
	created () {
		if (this.savedList && this.savedList.length) {
			this.localList = cloneDeep(this.savedList)
		} else {
			this.localList = cloneDeep(this.originalList)
		}
	},
	methods: {

		checkIfParentSelected (item) {
			let result = {
				checked: false,
				indeterminate: false
			}
			const localMatch = this.localList.find(localItem => localItem.sortKey === item.sortKey)
			if (localMatch) {
				if (item.children && item.children.length) {
					const childrenMatch = localMatch.children && (localMatch.children.length === item.children.length)
					result = {
						checked: childrenMatch,
						indeterminate: !childrenMatch && localMatch.children && localMatch.children.length > 0
					}
				} else {
					result.checked = true
				}
			}
			return result
		},

		checkIfChildSelected (parent, child) {
			const parentIsSelected = this.localList.find(localItem => localItem.sortKey === parent.sortKey)
			return !!(parentIsSelected && parentIsSelected.children && parentIsSelected.children.find( _child => child.sortKey === _child.sortKey))
		},

		handleChildCheckboxClick (parent, child) {
			const localParent = this.localList.find(localItem => localItem.sortKey === parent.sortKey)

			if (localParent) {

				if (localParent.children && localParent.children.find(_child => child.sortKey === _child.sortKey)) {

					localParent.children = localParent.children.filter(_child => _child.sortKey !== child.sortKey)

					if (localParent.children.length <= 0) {
						this.localList = this.localList.filter(item => item.sortKey !== parent.sortKey)
					}

				} else {
					if (!localParent.children) {
						localParent.children = []
					}
					localParent.children.push(child)
				}

			} else {
				const parentWithoutChildren = {
					...parent,
					children: []
				}
				parentWithoutChildren.children.push(child)
				this.localList.push(parentWithoutChildren)
			}
		},
		handleCheckboxClick (item) {
			const localMatch = this.localList.find(localItem => localItem.sortKey === item.sortKey)
			if (localMatch) {
				if (localMatch.children && localMatch.children.length) {
					if (localMatch.children.length === item.children.length) {
						this.localList = this.localList.filter(localItem => localItem.sortKey !==  item.sortKey)
					} else {
						localMatch.children = [...item.children]

					}
				} else {
					this.localList = this.localList.filter(localItem => localItem.sortKey !==  item.sortKey)
				}
			} else {
				this.localList.push(cloneDeep(item))
			}
		},
		handleSubmitForm () {
			if (this.localList && this.localList.length) {
				this.save(this.localList)
			} else {
				this.$refs.modal.shake()
				this.$store.dispatch(
					'Notification/ADD_NOTIFICATION',
					this.$t('common.messages.select-at-least-one-column')
				)
			}
		}
	}
}
</script>

<style lang="scss" module>


  	.modal {
		&__buttons {
			// margin-top: 20px;
			// display: flex;
			// justify-content: flex-end;
		}

		&__button {
			margin: 0;
			margin-bottom: 20px;

			&:last-child{
				margin-bottom: 0;
			}
		}
	}

  .title {
    // margin-bottom: $gutter;
  }

  .sub-title {
	  font-size: 13px;
  }

  .child-list {
	padding-left: $gutter * 2;
	margin: 0;
	margin-top: $gutter;

	  &__item {
		  display : flex;
		  margin-bottom: $gutter;

		  &:last-child{
			  margin-bottom: 0;
		  }
	  }
  }

  .list {
	  padding: 0;
	  margin: $gutter * 3 0;

	  &__item {
		  display : flex;
		  flex-direction: column;
		  margin-bottom: $gutter;
	  }
  }
</style>
